/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAssessmentNotificationWebHookForMicrosoftTeams extends models.WellArchitectedFrameworkAssessmentNotificationWebHook {
    constructor() {
        super();
        this.setDiscriminator("WellArchitectedFrameworkAssessmentNotificationWebHookForMicrosoftTeams");
    }

    getFixupPrototypeFunction() { return WellArchitectedFrameworkAssessmentNotificationWebHookForMicrosoftTeams.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAssessmentNotificationWebHookForMicrosoftTeams>): WellArchitectedFrameworkAssessmentNotificationWebHookForMicrosoftTeams {
        let obj = Object.assign(new WellArchitectedFrameworkAssessmentNotificationWebHookForMicrosoftTeams(), model);
        WellArchitectedFrameworkAssessmentNotificationWebHookForMicrosoftTeams.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAssessmentNotificationWebHookForMicrosoftTeams>): WellArchitectedFrameworkAssessmentNotificationWebHookForMicrosoftTeams {
        if (!model) return null;
        return WellArchitectedFrameworkAssessmentNotificationWebHookForMicrosoftTeams.newInstance(<WellArchitectedFrameworkAssessmentNotificationWebHookForMicrosoftTeams> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAssessmentNotificationWebHookForMicrosoftTeams) {
        if (!obj) return;

        models.WellArchitectedFrameworkAssessmentNotificationWebHookForMicrosoftTeams.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAssessmentNotificationWebHookForMicrosoftTeams): boolean {
        if (models.WellArchitectedFrameworkAssessmentNotificationWebHook.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAssessmentNotificationWebHookForMicrosoftTeams.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
